const MissionIdentityCardCase = () =>
  import(
    /* webpackChunkName: "missionIdentityCardCase" */
    "@/components/ssp/missions/mission/mission-identity-card/MissionIdentityCardCase.vue"
  );

const MissionIdentityCardRelation = () =>
  import(
    /* webpackChunkName: "missionIdentityCardRelation" */
    "@/components/ssp/missions/mission/mission-identity-card/MissionIdentityCardRelation.vue"
  );

const MissionIdentityCardProjectInfo = () =>
  import(
    /* webpackChunkName: "missionIdentityCardProjectInfo" */
    "@/components/ssp/missions/mission/mission-identity-card/MissionIdentityCardProjectInfo.vue"
  );

const MissionIdentityCardSiteInformation = () =>
  import(
    /* webpackChunkName: "missionIdentityCardSiteVisit" */
    "@/components/ssp/missions/mission/mission-identity-card/MissionIdentityCardSiteInformation.vue"
  );

export default [
  {
    path: "case",
    name: "case",
    component: MissionIdentityCardCase,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "relation",
    name: "relation",
    component: MissionIdentityCardRelation,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "information-project",
    name: "information-project",
    component: MissionIdentityCardProjectInfo,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "information-site",
    name: "information-site",
    component: MissionIdentityCardSiteInformation,
    meta: {
      showSubNavBar: true,
    },
  },
];
